import { SHOP_STATE_KEY } from '../state/redux/action-types';

/**
 * @private
 * getting the pickup offering status to pass to analytics
 *
 * @returns {string} no stores, stores but no offerings, offerings, no location detected
 */
export default function getPickupOfferingStatus(itemId) {
  const hasPostalCode = window.NikeShop?.get()?.postalCode;
  if (!hasPostalCode) {
    return 'no location detected';
  }
  const normalizedLocations =
    window.NikeShop.internalStore.getState()?.[SHOP_STATE_KEY]?.normalized?.locations ?? {};

  const hasStoresInRadius =
    Object.keys(normalizedLocations)
      ?.map(id => ({
        ...normalizedLocations[id],
      }))
      ?.filter(location => location.type === 'SEARCH')[0]?.results.length > 0;

  const storesWithAvailability = window.NikeShop.internalStore
    .getState()
    ?.[
      SHOP_STATE_KEY
    ]?.normalized?.offeringItems?.[itemId]?.fulfillmentOfferings.filter(fulfillmentAvailable => fulfillmentAvailable?.type === 'PICKUP' && fulfillmentAvailable?.location?.type === 'STORE_VIEWS').length;
  const hasItemsAvailability = storesWithAvailability > 0;

  if (hasStoresInRadius && hasItemsAvailability) {
    return 'offerings';
  } else if (hasStoresInRadius) {
    return 'stores but no offerings';
  }
  return 'no stores';
}
